module.exports = __webpack_public_path__ + "img/layout_horizontal_icon.e4770a6e.svg";